import tippy from 'tippy.js'

export default {
  bind (el, binding) {
    if (!binding.value) return
    tippy(el, {
      content: binding.value,
      placement: binding.arg || 'top',
      theme: 'light',
      duration: [150, 100],
      arrow: true,
      zIndex: 99999999,
      popperOptions: {
        strategy: 'fixed',
        modifiers: [
          { name: 'flip', options: { boundary: 'viewport' } }
        ]
      }
    })
  },
  update (el, binding) {
    if (el._tippy) {
      el._tippy.setContent(binding.value)
    }
  },
  unbind (el) {
    if (el._tippy) {
      el._tippy.destroy()
    }
  }
}
